import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'
import { currentPhotoByIdQueryKey, currentPhotosByEntityIdQueryKey } from '@/entities/Photos'
import {
  PhotoEditPolygonPhotoItemIdPolygonPatchPayload,
  topliApi,
  TortoiseContribPydanticCreatorModelsPhotoLeaf,
} from '@/shared/api/topli/TopliApi'

interface IProps {
  id: number
  polygons: PhotoEditPolygonPhotoItemIdPolygonPatchPayload
}

export const editPhotoPolygonsOnlyById = async ({ id, polygons }: IProps) => {
  const response = await topliApi.photo.updatePolygons(id, polygons)
  return response
}

export const usePhotoPolygonsOnlyByIdApi = (
  queryKeyForObjectUpdate: string,
  id: number,
): UseMutationResult<TortoiseContribPydanticCreatorModelsPhotoLeaf, Error, any> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: payload => editPhotoPolygonsOnlyById(payload),
    onSuccess: () => {
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: [queryKeyForObjectUpdate],
          refetchType: 'active',
        }),
        queryClient.invalidateQueries({
          queryKey: [currentPhotoByIdQueryKey, id],
          refetchType: 'active',
        }),
      ])
    },
  })
}
